
import { useView, autoinject, Container } from 'aurelia-framework'
import { PLATFORM } from 'aurelia-pal';
import TabViewModel from '../../../../Lib/Fs.SmartClient.Client/TabViewModel';


@autoinject()
  @useView(PLATFORM.moduleName("./EmissionMapGraphPublicSearchView.html"))
export default class EmissionMapGraphPublicSearchVM extends TabViewModel {
 
  attached() {
  
  }

  constructor() {
    super();
   
  }

  

}

